// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .custom-picker {
    /* background-color: aqua; */
    height: 42px;
    padding: 0 0 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/views/components/date-picker/index.css"],"names":[],"mappings":"CAAC;IACG,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[" .custom-picker {\r\n    /* background-color: aqua; */\r\n    height: 42px;\r\n    padding: 0 0 8px 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
